import { render, staticRenderFns } from "./AuthPasswordsReset.vue?vue&type=template&id=ec5d0044"
import script from "./AuthPasswordsReset.vue?vue&type=script&lang=js"
export * from "./AuthPasswordsReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports